import {type Action} from '@netx/core/bootstrap';
import {icon} from '@fortawesome/fontawesome-svg-core';
import {faCheckSquare, faImages} from '@netx/core-icons';
import {UserLevel} from '@netx/core-user/constants';
import {DownloadRequestActionLabel} from '../locales';

const iconOpts = {classes: ['fa-fw']};
const icons = {
	faCheckSquare: icon(faCheckSquare, iconOpts).html,
	faImages: icon(faImages, iconOpts).html,
};

export const DOWNLOAD_REQUEST_ROUTES = <const>{
	LIST: 'share/approvals',
	VIEW: 'share/request/review',
};

export type BaseVent = typeof BASE_EVENT;

export const BASE_EVENT = `download:request`;

export const DOWNLOAD_REQUEST_EVENT = <const>{
	LIST_ROUTE: `${BASE_EVENT}:list:route`,
	LIST: `${BASE_EVENT}:list`,
	VIEW: `${BASE_EVENT}:view`,
	VIEW_ROUTE: `${BASE_EVENT}:view:route`,
};

export const ACTIONS: Action<
	(typeof DOWNLOAD_REQUEST_EVENT)[keyof typeof DOWNLOAD_REQUEST_EVENT]
>[] = [
	{
		event: DOWNLOAD_REQUEST_EVENT.LIST,
		icon: icons.faCheckSquare,
		get label() {
			return DownloadRequestActionLabel.LIST;
		},
		userLevel: UserLevel.DIRECTOR,
	},
	{
		event: DOWNLOAD_REQUEST_EVENT.LIST_ROUTE,
		icon: icons.faCheckSquare,
		get label() {
			return DownloadRequestActionLabel.LIST;
		},
		route: DOWNLOAD_REQUEST_ROUTES.LIST,
		userLevel: UserLevel.DIRECTOR,
	},
	{
		event: DOWNLOAD_REQUEST_EVENT.VIEW,
		icon: icons.faImages,
		get label() {
			return DownloadRequestActionLabel.VIEW;
		},
		userLevel: UserLevel.DIRECTOR,
	},
	{
		event: DOWNLOAD_REQUEST_EVENT.VIEW_ROUTE,
		icon: icons.faImages,
		get label() {
			return DownloadRequestActionLabel.VIEW;
		},
		userLevel: UserLevel.DIRECTOR,
		route: (id) => `${DOWNLOAD_REQUEST_ROUTES.VIEW}/${id}`,
	},
];

export default ACTIONS;
